import React, { useState, useEffect, useRef } from "react";
import { Box } from "@mui/material";
import { useMeeting, usePubSub } from "@videosdk.live/react-sdk";
import { useLocation } from "react-router-dom";
import welcome from './../Assests/welcome.jpg';
import brb from './../Assests/brb.jpg';
import CompanyName_Logo_T from './../Assests/trans_dyrect.png';
import welcome_T from './../Assests/trans_welcome.png';
import { createStageOverlays, deleteStageOverlays, getStageOverlays } from "../Services/BannersApi";
import { FaEye, FaEyeSlash, FaTrash } from 'react-icons/fa';
import { createFileChangeHandler, triggerFileInput } from "../utils/fileUploadUtils";
import ImageUploadButton from "../Components/shared/ImageUploadButton";
import ImageGrid from "../Components/shared/ImageGrid";

const defaultOverlays = [
    { StageOverlayID: '1', StageOverlayUrl: welcome, isDefault: true },
    { StageOverlayID: '2', StageOverlayUrl: brb, isDefault: true },
    { StageOverlayID: '3', StageOverlayUrl: CompanyName_Logo_T, isDefault: true },
    { StageOverlayID: '4', StageOverlayUrl: welcome_T, isDefault: true }
];

const MeetingOverlayPanel = () => {
    const { publish } = usePubSub("UPDATE_MEETING_OVERLAY");
    const mMeeting = useMeeting();

    const [overlays, setOverlays] = useState(defaultOverlays);
    const [selectedOverlay, setSelectedOverlay] = useState(() => {
        return localStorage.getItem('selectedStageOverlayID') || null;
    });
    const [hoveredOverlay, setHoveredOverlay] = useState(null);
    const [uploading, setUploading] = useState(false);

    const fileInputRef = useRef(null);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const meetingId = queryParams.get("meetingId");

    useEffect(() => {
        fetchStageOverlays();
    }, []);

    useEffect(() => {
        const savedOverlayId = localStorage.getItem("selectedStageOverlayID");
        if (savedOverlayId) {
            setSelectedOverlay(savedOverlayId);
        }
    }, []);

    const fetchStageOverlays = async () => {
        try {
            const response = await getStageOverlays();
            if (response?.Data) {
                const apiOverlays = response.Data.map(overlay => ({
                    ...overlay,
                    isDefault: false
                }));
                setOverlays([...apiOverlays, ...defaultOverlays]);
            }
            const selectedStageOverlayID = localStorage.getItem('selectedStageOverlayID');
            if (selectedStageOverlayID) {
                setSelectedOverlay(selectedStageOverlayID);
            }
        } catch (error) {
            console.error('Error fetching logos:', error);
        }
    };

    const handleFileChange = createFileChangeHandler(setUploading, 'StageOverlayBase64', createStageOverlays, fetchStageOverlays);

    const handleDeleteOverlay = async (overlay) => {
        try {
            if (selectedOverlay === overlay.StageOverlayID) {
                setSelectedOverlay(null);
                publish({ OverlayId: null, OverlayUrl: null, visibility: false }, { persist: true });
                localStorage.removeItem('selectedStageOverlayID');
            }
            await deleteStageOverlays(overlay.StageOverlayID);
            fetchStageOverlays();
        } catch (error) {
            console.error("Error deleting overlay:", error);
        }
    };

    const handleOverlayClick = (overlayId) => {
        console.log('overlayId', overlayId);
        localStorage.setItem('selectedStageOverlayID', overlayId);

        if (selectedOverlay === overlayId) {
            console.log('overlay123', overlayId);
            setSelectedOverlay(null);
            publish({ OverlayId: null, OverlayUrl: null, visibility: false }, { persist: true });
            localStorage.removeItem('selectedStageOverlayID');
        } else {
            console.log('overlay123 else', overlayId);
            setSelectedOverlay(overlayId);
            const overlay = overlays.find(b => b.StageOverlayID === overlayId);
            console.log('overlay', overlay);
            publish({ OverlayId: overlayId, OverlayUrl: overlay.StageOverlayUrl, visibility: true }, { persist: true });
            localStorage.setItem('selectedStageOverlayID', overlayId);
        }
    };

    const renderOverlayActions = (overlay, isSelected, isHovered) => (
        <div
            style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                backgroundColor: 'rgba(0, 0, 0, 0.6)',
                color: 'white',
                padding: '0.5vh 1vw',
                borderRadius: '0.5vh',
                cursor: 'pointer',
                visibility: isSelected || isHovered ? 'visible' : 'hidden',
                display: 'flex',
                transition: 'transform 0.3s ease-out, opacity 0.3s ease-out',
            }}
        >
            <div
                onClick={(e) => {
                    e.stopPropagation();
                    handleOverlayClick(overlay.StageOverlayID);
                }}
                style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', justifyContent: 'center', padding: '0.5vh 1vw' }}
            >
                {isSelected ?
                    <FaEyeSlash style={{ fontSize: '1.6vh' }} />
                    :
                    <FaEye style={{ fontSize: '1.6vh' }} />
                }
                {!overlay.isDefault && (
                    <FaTrash
                        style={{
                            marginLeft: '1vw',
                            cursor: 'pointer',
                            color: 'red',
                            fontSize: '1.6vh',
                        }}
                        onClick={(e) => {
                            e.stopPropagation();
                            handleDeleteOverlay(overlay);
                        }}
                    />
                )}
            </div>
        </div>
    );

    return (
        <Box color="white">
            <div style={{ maxHeight: "75vh", overflowY: "auto" }}>
                <input
                    type="file"
                    ref={fileInputRef}
                    style={{ display: "none" }}
                    accept="image/png, image/jpeg"
                    onChange={handleFileChange}
                />
                <ImageGrid
                    items={overlays}
                    selectedId={selectedOverlay}
                    hoveredId={hoveredOverlay}
                    onHover={(id) => setHoveredOverlay(id)}
                    onLeave={() => setHoveredOverlay(null)}
                    onClick={(id) => handleOverlayClick(id)}
                    getId={(o) => o.StageOverlayID}
                    getUrl={(o) => o.StageOverlayUrl}
                    getAlt={(o) => `Overlay ${o.StageOverlayID}`}
                    renderOverlay={renderOverlayActions}
                />
                <ImageUploadButton
                    uploading={uploading}
                    onUpload={() => triggerFileInput(fileInputRef)}
                    label="Add Overlay Image"
                />
            </div>
        </Box>
    );
};

export default MeetingOverlayPanel;
